import gsap from 'gsap';

const onceArchive = (container) => {

    const mapPin = document.querySelector('.bg-pin-map');
    // const mapMask = document.querySelector('#circleMask');
    const headerLogo = document.querySelector('.bg-header-logo');
    let navLinks = document.querySelectorAll('.main-menu > .menu-item');
    let postItems = document.querySelectorAll('.bg-post-item');

    const tl = gsap.timeline({
        defaults: {
            duration: .6, ease: "circ.out"
        }
    })
    const linksAnim = gsap.timeline()

    linksAnim
    .to( navLinks, { autoAlpha:1, yPercent: 0, backgroundColor: 'var(--color-grey)', stagger: .4, ease: "back.in" })
    .to( navLinks, { backgroundColor: 'var(--button-active-color)', stagger: .4 }, '<.4')
    .to( navLinks, { stagger: .4, clearProps:"all" }, '<')

    tl
    .set(navLinks, { autoAlpha:0, yPercent: 101  })
    .to( '.bg-spinner' , {opacity: 0} )
    .to( '.bg-layout', { opacity: 1} )
    // .from( mapPin, { y: "-110", ease: 'bounce.out', duration: .2 })
    .from( mapPin, { y: "-110", ease: 'power4.out', duration: .2, clearProps:"all" })
    // .from( mapPin, { y: "-=130", ease: 'bounce.out', duration: .2, clearProps:"all" })
	.fromTo("#circleMask", { opacity: 1, scale:.1, transformOrigin: "center center" }, { opacity: 1, scale: 300, transformOrigin: "center center", duration: 1, ease: "circ.in" }, "-=.5")
    .fromTo( headerLogo, { y: -20, opacity: 0  }, { y: 0, opacity: 1, duration: .6, clearProps:"all" }, "-=.6")
    .add(linksAnim, .4, "<")
    .from( postItems, { autoAlpha: 0, y: 20, stagger: .35, duration: .7 })


    // tl.timeScale(0.2)

    return tl
}

export default onceArchive;